import React from 'react';
import type { TableTopBarProps } from '../types';
import { getRoomLabelText } from '@src/utilities/common';

const TableTopBar: React.FC<TableTopBarProps> = ({
    tabs,
    mainCategory,
    activeTable,
    badgeCounts,
    onCategoryChange,
    onTableChange,
}) => {
    const categoryEntries = Object.entries(tabs).sort().reverse();
    const tableCount = tabs[mainCategory] || 0;

    return (
        <div className="posv2-topbar">
            {/* Category tabs (Table, Hut, Room, etc.) */}
            <div className="posv2-topbar__cats">
                {categoryEntries.length > 1 &&
                    categoryEntries.map(([catKey]) => {
                        const activeTables = badgeCounts[catKey]
                            ? Object.keys(badgeCounts[catKey]).length
                            : 0;

                        return (
                            <button
                                key={catKey}
                                className={`posv2-topbar__cat-btn ${mainCategory === catKey ? 'active' : ''}`}
                                onClick={() => onCategoryChange(catKey)}
                            >
                                {catKey}
                                {activeTables > 0 && (
                                    <span className="posv2-topbar__badge">{activeTables}</span>
                                )}
                            </button>
                        );
                    })}
            </div>

            {/* Numbered sub-tables */}
            <div className="posv2-topbar__tables">
                {Array.from({ length: tableCount }, (_, idx) => {
                    const tableName = `${mainCategory}-${idx + 1}`;
                    const itemCount = badgeCounts[mainCategory]?.[tableName] || 0;

                    return (
                        <button
                            key={tableName}
                            className={`posv2-topbar__table-btn ${activeTable === tableName ? 'active' : ''} ${itemCount ? 'has-items' : ''}`}
                            onClick={() => onTableChange(tableName)}
                        >
                            <span className="posv2-topbar__table-label">{getRoomLabelText(mainCategory, idx + 1)}</span>
                            {!!itemCount && (
                                <span className="posv2-topbar__table-count">{itemCount}</span>
                            )}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default React.memo(TableTopBar);
